<template>
  <div v-if="isEnable" class="d-flex align-items-center">
    {{ title }}
    <img v-bind:src="`assets/img/loader.gif`" title="Loading..." class="ml-2" />
  </div>
</template>
<script>
export default {
  name: "Loader",
  props: ["isEnable", "title"],
};
</script>
